import { useEffect } from 'react';
import { BadgeText, Button, Flex, Spacer } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { TopBar } from '@component/top_bar.component';
import { withTranslation } from '@application/i18n/with_translation';
import { useResolveController } from '@visiba/instantiation';
import { CreateNewMessageController } from '../view_create_new_message.controller';
import { Async } from '@component/async.component';
import { Article } from '@component/article.component';
import { ButtonArrange } from '@component/button_arrange.component';
import { Title } from '@component/title.component';
import { useAnalyticContext } from '@application/analytic/analytic_link/mod';
import { DataList } from '@component/data_list.component';

export function ScreenStart() {
	const controller = useResolveController(CreateNewMessageController);
	const analyticCtx = useAnalyticContext();

	function handleNext() {
		analyticCtx.trackEvent('Clicked', 'Next button');
		controller.goToScreen('reason-for-visit');
	}

	useEffect(
		function whenMount() {
			analyticCtx.service.trackPageView({
				customTitle: 'Create new message: Start',
			});
		},
		[analyticCtx],
	);

	return (
		<>
			<TopBar.Content skipAbortDialog={controller.getCurrentBasket() == null} />

			<Async derive={controller.flowData}>
				{(flowData) => (
					<Flex grow={1} gap={tokens.spacing.x2}>
						<Flex grow={1} gap={tokens.spacing.x1}>
							<Title
								title={flowData.screenStart.title ?? withTranslation('View.CreateNewMessage.ScreenStart.FallbackTitle')}
								titleSize='small'
							/>

							{flowData.price ? (
								<DataList.Root>
									<DataList.Item label={withTranslation('Common.Label.Cost')}>
										<BadgeText variant='info'>{flowData.price}</BadgeText>
									</DataList.Item>
								</DataList.Root>
							) : null}

							<Spacer vertical={tokens.spacing.x1_5}>
								<Article>
									{flowData.screenStart.description ?? withTranslation('View.CreateNewMessage.ScreenStart.FallbackDescription')}
								</Article>
							</Spacer>
						</Flex>

						<ButtonArrange>
							<Button onClick={handleNext} loading={controller.screenState.value === 'busy'}>
								{withTranslation('PW.Common.Next')}
							</Button>
						</ButtonArrange>
					</Flex>
				)}
			</Async>
		</>
	);
}
